{
  "about": {
    "paragraph": "We are committed to addressing the challenges of the AGEC law and informing our customers about the origin and environmental qualities of our products.",
    "title": "About"
  },
  "lastUpdate": "Last Update Date : ",
  "loading": {
    "dataPending": "is currently collecting this information",
    "pendingLocation": "Pending location"
  },
  "detailedProductComposition": {
    "title": "Composition"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Apparel Manufacturing",
    "FOOTWEAR_FINISHING": "Footwear Finishing",
    "FOOTWEAR_STITCHING": "Footwear Stitching",
    "FOOTWEAR_ASSEMBLING": "Footwear Assembling",
    "FABRIC_WEAVING_OR_KNITTING": "Fabric Weaving or Knitting",
    "FABRIC_DYEING_PRINTING": "Fabric Dyeing or Printing",
    "YARN_PROVIDER": "Yarn Provider",
    "YARN_DYEING_PRINTING": "Yarn Dyeing or Printing",
    "LEATHER_TANNING": "Leather Tanning",
    "LEATHER_DYEING_PRINTING": "Leather Dyeing or Printing",
    "ACCESSORY_PROVIDER": "Accessory Provider",
    "YARN_MATERIAL_PRODUCTION": "Yarn Material Production",
    "FABRIC_SPINNING": "Fabric Spinning",
    "FABRIC_MATERIAL_PRODUCTION": "Fabric Material Production",
    "LEATHER_MATERIAL_PRODUCTION": "Leather Material Production",
    "LEATHER_FARM": "Breeding Farm",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Accessory Raw Material Provider",
    "COATING": "Coating"
  },
  "other": {
    "microplastics_bold": "releases microplastics ",
    "paragraph1": "This product contains ",
    "paragraph1_100": "This product contains 100% recycled materials.",
    "paragraph2_1": "This product ",
    "paragraph2_2": "  into the environment during washing: ",
    "paragraph2_3": "by mass of the product is made up of synthetic fibers.",
    "paragraph3": "Information about the potential presence of hazardous substances in the application: ",
    "recycled_matertials_bold": "at least {{percent}}% recycled materials.",
    "recycled_matertials_bold_50": "more than 50% ",
    "title": "Other environmental qualities and features"
  },
  "packaging": {
    "recyclable": "Recyclable: Packaging is recyclable.",
    "recycled": "Recyled materials: Packaging contains at least {{percent}}% recycled materials.",
    "recycled_100": "Recyled materials: Packaging contains 100% recycled materials.",
    "title": "Environmental qualities and features of the packaging"
  },
  "title": "Product qualities and environmental characteristics",
  "traceability": {
    "paragraph": "This refers to the origin of your product in its first three production stages, from its creation to the weaving and dyeing of its main material.",
    "title": "Product Traceability"
  },
  "ecoScore": {
    "title": "EcoScore",
    "b2b": "Environmental cost : {{cost}} impact points"
  }
}
